import { render, staticRenderFns } from "./MainDeposit.vue?vue&type=template&id=69b11ade&scoped=true"
import script from "./MainDeposit.vue?vue&type=script&lang=ts"
export * from "./MainDeposit.vue?vue&type=script&lang=ts"
import style0 from "./MainDeposit.vue?vue&type=style&index=0&id=69b11ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b11ade",
  null
  
)

export default component.exports